<template>
  <v-tooltip right open-on-click v-if="!isLoading && !hide">
    <template v-slot:activator="{ on }">
      <v-row no-gutters v-on="on">
        <v-icon class="pr-1" size="16px">mdi-information-variant-circle-outline</v-icon>
        <span :class="valid ? 'valid' : 'invalid'" v-if="!isError">
          {{ valid ? 'VIES válido' : 'VIES inválido' }}
        </span>
        <span class="invalid" v-else>
          {{ message }}
        </span>
      </v-row>
    </template>
    <span
    >La validación del VIES es un dato a nivel <strong>informativo.</strong>
      <template v-if="valid && !isError">
        <br/><br/>
        <strong>Estado</strong> {{ valid ? 'VALIDADO' : 'NO VALIDADO' }} <br/>
        <strong>Nombre:</strong> {{ name }} <br/>
        <strong>Dirección:</strong> {{ address }} <br/>
        <strong>País:</strong> {{ countryCode }} <br/>
        <strong>NIF:</strong> {{ vatNumber }} <br/>
      </template>
    </span>
  </v-tooltip>
</template>

<script>
import {ViesValidation} from "@/modules/invoices/app/ViesValidation";
import {sync_command_dispatcher} from "@/api/client";

export default {
  name: "ViesValidator",
  data() {
    return {
      isLoading: false,
      isError: false,
      hide: false,
      valid: false,
      countryCode: "",
      vatNumber: "",
      name: "",
      address: "",
      message: "",
    };
  },
  props: {
    third: {
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  methods: {
    validateVies() {
      try {
        this.isLoading = true;
        if (!this.third.cif) {
          // Tercero sin CIF
          this.hide = true;
          this.isLoading = false;
          return;
        }
        let cif = this.third.cif.startsWith(this.third.country) ? this.third.cif : this.third.country + this.third.cif;

        new ViesValidation(sync_command_dispatcher).run({
          cif: cif,
        }).then((response) => {
          if (response['output'].error) {
            this.message = response['output'].error
            this.isError = true;
            this.valid=false;
            return;
          }
          this.countryCode = response['output'].countryCode || "";
          this.vatNumber = response['output'].vatNumber || "";
          this.name = response['output'].name || "";
          this.address = response['output'].address || "";
          this.valid = response['output'].valid || false;
        }).catch((error) => {
          this.message = "Error al obtener datos de VIES"
          this.isError = true;
        });
      } catch (error) {
        this.isError = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.validateVies();
  },

};
</script>
<style scoped>
.valid {
  font-size: 12px;
  color: green;
}

.invalid {
  font-size: 12px;
  color: red;
}
</style>
